import { lazy } from 'react';
export const LazyResetPassword = lazy(() => import('@/pages/ResetPassword'));
